export { default } from './GuidelineExpanderCardContent';
